import { Injectable, NgZone } from '@angular/core';
import { Functions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions';
import { ImagePresignRequirements, ImagePresignReturn } from '../../../globalTypes/image.types';
import { FilePresignRequirements, FilePresignReturn } from '../../../globalTypes/file.types';
import { onCallFunctions } from '../../../globalTypes/backend.api.types';

export interface UploadedFile {
  url: string;
  filename: string;
  contentType: string;
  sizeInBytes: number;
  width: number;
  height: number;
  position?: number;
  key?: string;
}

@Injectable({ providedIn: 'root' })
export class UploadService {


  constructor(
    private functions: Functions,
    private ngZone: NgZone,
  ) {
  }

  async presignUpload(payload: ImagePresignRequirements): Promise<ImagePresignReturn> {
    const callable = this.ngZone.run(() => httpsCallable<ImagePresignRequirements,ImagePresignReturn>(this.functions, onCallFunctions.presignUpload));
    const result: HttpsCallableResult<ImagePresignReturn> = await callable(payload);
    return result.data;
  }

  async presignFileUpload(payload: FilePresignRequirements): Promise<FilePresignReturn> {
    const callable = this.ngZone.run(() => httpsCallable<FilePresignRequirements,FilePresignReturn>(this.functions, onCallFunctions.presignFileUpload));
    const result: HttpsCallableResult<FilePresignReturn> = await callable(payload);
    return result.data;
  }

  // async registerUpload(payload: { key: string; metadata: UploadedFile }) {
  //   const fn = httpsCallable(this.functions,   onCallFunctions.registerUpload);
  //   await fn(payload);
  // }

  // async finalizeUploads(payload: { type: string; id: string | number; keys: string[] }): Promise<UploadedFile[]> {
  //   const fn = httpsCallable(this.functions, onCallFunctions.finalizeUploads);
  //   const res: any = await fn(payload);
  //   return res.data.files || [];
  // }

  async deleteUploadedImages(ids: string[]) {
    const fn = httpsCallable<{ids: string[]}, {success: boolean}>(this.functions, 'deleteImages');
    await fn({ ids });
  }
}
